import { render, staticRenderFns } from "./RivalPatent.vue?vue&type=template&id=c15418be"
import script from "./RivalPatent.vue?vue&type=script&lang=js"
export * from "./RivalPatent.vue?vue&type=script&lang=js"
import style0 from "./RivalPatent.vue?vue&type=style&index=0&id=c15418be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports